<template>
  <div class="news-home">
    <div class="fullwidth small-bottom-padding narex">
      <div class="title-area flex-start">
        <editable-item page="news" item="title" :loaded="loaded" />
        <search-widget right :placeholder="$nippets.newsPage.searchText" v-on:select="goArtist" />
      </div>
      <div class="news-matrix">
        <div class="news-square nav">
          <div>
            <div class="tag-area">
              <ix-router-link to="/news" class="tag">{{ $nippets.newsPage.all }}</ix-router-link>
              <ix-router-link v-for="item in tags" :key="item.tag"
              class="tag" :to="'/news/tags/' + $k.tagToUrl(item.tag)" v-html="(item.trans || item.tag)"></ix-router-link>
            </div>
          </div>
          <div>
            <div class="mini-heading">{{ $nippets.followUs }}</div>
            <follow-us />
          </div>
          <div class="subscribe-box">
            <div class="mini-heading pbot">{{ $nippets.subscribeSignUp }}</div>
            <subscribe-widget /> 
          </div>
        </div>
        <news-panel v-for="item in articles" :key="item.news_id" :item="item" v-on:click="goStory(item)" />
      </div>
      <div class="a-flex">
        <small-button large v-on:click="loadMore" v-show="curdata.length > max">{{ $nippets.more }}</small-button>
        <div v-if="curdata.length <= max"></div>
        <top-button />
      </div>
    </div>
    <news-popup :newsid="popid" v-model="showing" />
  </div>
</template>

<script>
import EditableItem from '@/components/editors/EditableItem.vue'
import SearchWidget from '@/components/widgets/BaseSearchWidget.vue'
import SubscribeWidget from '@/components/widgets/SubscribeWidget.vue'
import NewsPanel from './NewsPanel.vue'
import FollowUs from '@/components/panels/FollowUs.vue'
import TopButton from '@/components/buttons/TopButton.vue'
import NewsPopup from './NewsPopup.vue'
import MetatagPage from '@/mixins/MetatagPage.js'
import Trans from '@/utils/trans.js'

const minicache = {}
const pagesize = 30

export default {
  mixins: [
    MetatagPage
  ],
  components: {
    EditableItem,
    SearchWidget,
    NewsPanel,
    SubscribeWidget,
    FollowUs,
    TopButton,
    NewsPopup
  },
  props: {
    tagname: String,
    id: String
  },
  data () {
    return {
      loaded: false,
      tags: [],
      max: 47,
      curdata: [],
      popid: '0',
      showing: false
    }
  },
  computed: {
    articles () {
      return this.curdata.slice(0, this.max)
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      
      this.loadData()
    },
    loadData: async function () {
      this.max = 47
      this.curdata = []
      this.$k.fetchStories('news', () => {
        this.loaded = true
      })
      if(this.tagname){
        this.origUrl = this.$route.path
        let tg = this.tagname.toLowerCase()
        if(minicache[tg]){
          this.curdata = minicache[tg]
        }
        else {
          let url = this.$k.getNewsUrl('news/bytag/' + tg + '/')
          let res = await this.$apix.get(url)
          minicache[tg] = res.data
          this.curdata = minicache[tg]
        }
        if(this.articles.length === 0) {
          this.$k.messageBox(this.$nippets.news, this.$nippets.search.notFoundMessage)
        }
      }
      else {
        if(minicache['all']){
          this.curdata = minicache['all']
        }
        else {
          let url = this.$k.getNewsUrl('news/current/')
          
          let res = await this.$apix.get(url)
           minicache['all'] = res.data
           this.curdata = minicache['all']
        }
        
      }
      if(this.$store.state.newstags === null) {
        
        let tagdata = await this.$apix.get('news/tags')
        if(this.$store.getters.isNewsTranslatable) {
          await Trans.getTagTranslations(this.$apix, tagdata.data, this.$store.state.lang)
        }
        this.$store.commit('setNewsTags', tagdata.data)
      }
      this.tags = this.$store.state.newstags
    },
    
    loadMore () {
      if(this.max < this.curdata.length)
      this.max += pagesize
      if(this.max > this.curdata.length){
        this.max = this.curdata.length
      }
    },
    goStory (item) {
      this.popid = '' + item.news_id
      this.showing = true
    },
    async goArtist(artist) {
      let t = '/news/tags/' + this.$k.tagToUrl(artist.formatted_name)
      this.$ixr.push(t)
    },
    async handleTag (tag) {
      let t = '/news/tags/' + this.$k.tagToUrl(tag)
      this.$ixr.push(t)
    }
  },
  watch: {
    tagname () {
      if(!this.id) {
        this.loadData()
      }
    },
    '$route.path': function () {
      this.showing = false
    }
  }
}
</script>

<style>
.news-home h1{
  width:70%;
}

.news-matrix{
  display:flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height:800px;
}


.mini-heading{
  font-size:17px;
  color:#4a4f54;
}

.mini-heading.pbot{
  margin-bottom:6px;
}

.news-home .tag.router-link-exact-active{
  background-color:#8b6f4b;
}

.a-flex{
  display:flex;
  justify-content: space-between;
  align-items:flex-start;
}

@media screen and (max-width:1100px){
  .news-square{
    width:49%;
    margin-bottom:1.5%;
  }
}

@media screen and (max-width:760px){
  .news-square{
    width:100%;
    margin-bottom:1%;
  }

  .title-area.flex-start{
    display:block;
  }

  .news-matrix{
    margin-top:20px;
  }
}

</style>